import React, { useEffect, useState } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { parse } from 'query-string'
import { loadAdmin } from '../../store/actions/auth'

import LoginForm from './LoginForm'
import LoadingScreen from '../Common/LoadingScreen'
import Info from '../Common/Info'
import { connect } from 'react-redux'
import { validateEmail } from '../../utils/parseData'

function Login({ auth, loadAdmin }) {
  const [formObj, setFormObj] = useState({
    state: 'idle',
    email: '',
    password: '',
    emailStatus: '',
  })
  const { authError, isAuthorized, loading } = auth
  const { search } = useLocation()
  const queryParams = parse(search)
  const queryParaToken = queryParams.token

  const onChangeHandler = (e) => {
    const fieldName = e.target.name
    const fieldValue = e.target.value
    setFormObj((data) => ({
      ...data,
      [fieldName]: fieldValue,
    }))
  }

  const emailHandler = (e) => {
    const value = e.target.value
    const isValid = validateEmail(value)
    setFormObj((data) => ({
      ...data,
      email: e.target.value,
      emailStatus: isValid ? 'is-valid' : '',
    }))
  }

  useEffect(() => {
    if (queryParaToken !== undefined) {
      loadAdmin(queryParaToken, setFormObj)
    } else {
      loadAdmin(localStorage.token, setFormObj)
    }
  }, [queryParaToken, loadAdmin])

  if (loading === null) {
    return <LoadingScreen />
  }

  if (isAuthorized) {
    return <Redirect to='/' />
  }

  return (
    <div id='LoginRoute' className='container-fluid bg-light p-0'>
      {authError && <Info messages={[...authError]} alertType='alert-danger' />}

      <div className='wrapper'>
        <div className='login-illustration'>
          <div className='backgroundImage'></div>
          <div className='meta'>
            <div>WELCOME TO XCBM</div>
            <span>
              Xebia's portal to manage badges
              <br />
              to provide badges to users
            </span>
          </div>
        </div>
        <div className='login-form p-4'>
          <LoginForm
            formObj={formObj}
            setFormObj={setFormObj}
            emailHandler={emailHandler}
            onChangeHandler={onChangeHandler}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({ auth })

export default connect(mapStateToProps, { loadAdmin })(Login)
